import React, { PropsWithChildren } from 'react';
import { Control } from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';
import { DialogFooter } from '@/components/ui/dialog';
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import Dialog from '@/components/template/Dialog';
import InlineInput from '@/components/InlineInput';
import RoleSelector from '@/components/QuerySelectors/RoleSelector';

import { InviteForm } from './schema';

interface IProps extends PropsWithChildren {
  control: Control<InviteForm>;
  onSubmit: (event: React.SyntheticEvent) => void;
  isLoading: boolean;
  onClose: () => void;
}

const InviteDialogView: React.FC<IProps> = ({
  control,
  isLoading,
  onSubmit,
  children,
  onClose,
}) => (
  <Dialog
    title="Convidar um novo membro"
    description="Convide um novo membro para o seu projeto inserindo o endereço de e-mail abaixo."
    trigger={children}
    onClose={onClose}
  >
    <form onSubmit={onSubmit}>
      <div className="grid gap-4 py-4">
        <FormField
          control={control}
          name="fullName"
          render={({ field }) => (
            <InlineInput
              title="Nome Completo"
              disabled={isLoading}
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <InlineInput title="E-mail" disabled={isLoading} {...field} />
          )}
        />

        <FormField
          control={control}
          name="externalId"
          render={({ field }) => (
            <InlineInput title="ID Externo" disabled={isLoading} {...field} />
          )}
        />

        <FormField
          control={control}
          name="roles"
          render={({ field }) => (
            <FormItem className="grid grid-cols-4 items-center gap-4">
              <FormLabel className="text-right">Funções</FormLabel>
              <div className="col-span-3">
                <RoleSelector
                  className="w-full justify-between"
                  value={field.value}
                  onChange={field.onChange}
                  multiple
                />
                <FormMessage />
              </div>
            </FormItem>
          )}
        />
      </div>
      <DialogFooter>
        <Button className="hidden" variant="secondary">
          Importar de CSV
        </Button>

        <Button type="submit" disabled={isLoading}>
          {isLoading && <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />}
          Convidar
        </Button>
      </DialogFooter>
    </form>
  </Dialog>
);

export default InviteDialogView;
